

















































































































import {Component, Mixins, Ref, Watch, Prop} from 'vue-property-decorator';
import NoticeBox from '@/components/claim/popup/NoticeBox.vue';
import ClaimProduct from '@/components/claim/popup/ClaimProduct.vue';
import ReturnWithdrawReason from '@/components/claim/popup/ReturnWithdrawReason.vue';
import ClaimInformation from '@/components/claim/popup/ClaimInformation.vue';
import ProductAmountDetail from '@/components/claim/popup/ProductAmountDetail.vue';
import ReturnDeliveryAmount from '@/components/claim/popup/ReturnPopup/ReturnDeliveryAmount.vue';
import DiscountAndDeliveryRecalculate from '@/components/claim/popup/DiscountAndDeliveryRecalculate.vue';
import RefundAmount from '@/components/claim/popup/CancelPopup/RefundAmount.vue';
import BenefitRecalculate from '@/components/claim/popup/BenefitRecalculate.vue';
import NaverPayReturnHold from '@/components/claim/popup/NaverPayReturnHold.vue';
import NaverPayAmountDetail from '@/components/claim/popup/NaverPayAmountDetail.vue';
import {ClaimStatusType, ReasonType, RefundType, ResponsibleObjectType, ReturnForm, ReturnWayType} from '@/types/claim';
import PopupBasic from '@/components/claim/popup/mixins/PopupBasic';
import {
  isReturnProcBeforeReceive,
  isReturnProcRequestRefund,
  isReturnProcWaitingRefund,
  isReturnRefundAmtAdjustRequested,
  isReturnRejectRequest,
  isReturnRequest
} from '@/components/claim/popup/validations';
import {ReturnsPredict} from 'supporter';
import {commaNumStringToNumber} from '@/utils/dataReplaceUtils';
import {ncpPopup} from '@/utils/ncp';

@Component({
  components: {
    NoticeBox,
    ClaimProduct,
    ReturnWithdrawReason,
    ClaimInformation,
    ProductAmountDetail,
    ReturnDeliveryAmount,
    DiscountAndDeliveryRecalculate,
    RefundAmount,
    BenefitRecalculate,
    NaverPayReturnHold,
    NaverPayAmountDetail
  },
  computed: {
    isReturnRequest,
    isReturnRejectRequest,
    isReturnProcRequestRefund,
    isReturnProcBeforeReceive,
    isReturnProcWaitingRefund,
    isReturnRefundAmtAdjustRequested,
    isNaverPayClaim(): boolean{
      return this.claimNoResponseData.originalPayType === 'NAVER_PAY'
    },
    showRefundProcessButton(): boolean{
      return !this.isModifyMode && (this.isReturnRefundAmtAdjustRequested || this.isReturnProcRequestRefund)
    },
    showRefundWithdrawalButton(): boolean{
      return !this.isModifyMode && (this.isReturnRequest || this.isReturnProcRequestRefund || this.isReturnProcBeforeReceive || this.isReturnRefundAmtAdjustRequested);
    },
    showWithdrawalButton(): boolean{
      // 역할을 똑같은데, 레거시기준 디자인만 다른 철회 버튼이 2개다. 차이점은 네이버 페이때 등장하는게 gray색의 철회 버튼이다.
      return !this.isModifyMode && this.isReturnProcWaitingRefund
    },
    showReturnApproveButton(): boolean{
      return !this.isModifyMode && this.isReturnRequest
    },
    showReturnWithdrawApproveButton(): boolean{
      return !this.isModifyMode && this.isReturnRejectRequest
    },
    showNaverPayApproveButton(): boolean{
      if(!this.isNaverPayClaim){
        return false;
      }

      return !this.isModifyMode && this.isReturnProcWaitingRefund;
    },
    showNaverPayWithHoldButton(): boolean{
      if(!this.isNaverPayClaim){
        return false;
      }

      return !this.isModifyMode && this.isReturnProcWaitingRefund;
    },
    showNaverPayWithHoldCancelButton(): boolean{
      if(!this.isNaverPayClaim){
        return false;
      }

      return !this.isModifyMode && this.isReturnProcWaitingRefund;
    },
    showNaverPayAmountDetail(){
      return this.isNaverPayClaim && !!this.claimNoResponseData.externalData?.naver
    },
  }
})
export default class ReturnPopup extends Mixins(PopupBasic){
  @Ref('returnDeliveryAmount')
  private readonly returnDeliveryAmountComponent!: ReturnDeliveryAmount
  @Ref('refundAmount')
  private readonly refundAmountComponent!: RefundAmount
  @Ref('discountAndDeliveryRecalculate')
  private readonly discountAndDeliveryRecalculateComponent!: DiscountAndDeliveryRecalculate
  private isModifyMode = false;
  private returnsPredict: null | ReturnsPredict = null
  private showNaverPayHoldPopup = false;
  private formData: ReturnForm = {
    responsibleObjectType: this.claimNoResponseData.responsibleObjectType as ResponsibleObjectType,
    refundType: this.claimNoResponseData.displayRefundType.refundType as RefundType,
    reasonDetail: this.claimNoResponseData.claimReasonDetail, // 클레임 사유
    sellerPaysClaimedDelivery: this.claimNoResponseData.sellerPaysClaimedDelivery,
    reasonType: this.claimNoResponseData.claimReasonType as ReasonType,
    refundBankAccount: {
      depositorName: this.claimNoResponseData.refundBankAccount?.depositorName,
      bankName: this.claimNoResponseData.refundBankAccount?.bankName,
      bank: this.claimNoResponseData.refundBankAccount?.bank,
      account: this.claimNoResponseData.refundBankAccount?.account,
    },
    returnWayType: this.claimNoResponseData.returnWayType as ReturnWayType,
    returnDeliveryProposedAmt: this.claimNoResponseData.returnDeliveryAdjustAmt, // 반품배송조정금액
    returnDeliveryProposedReason: this.claimNoResponseData.returnDeliveryAmtAdjustReason, // 반품배송조정사유
    refundAdjustAmt: this.claimNoResponseData.refundAdjustAmt.toLocaleString(),
    refundAdjustReason: this.claimNoResponseData.refundAdjustReason ,
    delivery: {
      invoiceNo: this.claimNoResponseData.returnDelivery?.invoiceNo ?? null,
      deliveryCompanyType: this.claimNoResponseData.returnDelivery?.deliveryCompanyType ?? '',
      evadesReturnProcess: this.claimNoResponseData.returnDelivery?.evadesReturnProcess ?? false,
    }
  };

  @Prop({required: true})
  private deliveryCompleteYmdt: string;

  private get isRental() {
    return this.claimNoResponseData.originalPayType === 'RENTAL';
  }

  mounted() {
    (window as any).closeProcess = this.closeProcess;
  }

  @Watch('formData.refundAdjustAmt')
  private onChangeRefundAdjustAmt(){
    this.predictAndResetAmounts()
  }


  //반품수거방법 변경 시 발생하는 액션
  @Watch('formData.returnWayType', {immediate: false})
  private onChangeReturnWayType(){
    this.predictAndResetAmounts()
  }

  //반품사유 변경 시 발생하는 액션
  @Watch('formData.reasonType',{immediate: false})
  private onChangeReasonType(){
    this.changeResponsibleObjectTypeByRefundType()
    this.resetDeliveryProposedAmt() // 귀책에 따른 조정 금액 리셋 여부
    this.changeSellerPaysClaimedDelivery()
    this.predictAndResetAmounts()
  }

  private async predictAndResetAmounts(){
    if(!this.validation('predict')){
      return
    }

    await this.postReturnsNoPredict()

    this.returnDeliveryAmountComponent.resetAsPredictedAmounts()
    this.refundAmountComponent.resetAsPredictedAmounts()
    this.discountAndDeliveryRecalculateComponent.resetAsPredictedAmounts()
  }

  private changeResponsibleObjectTypeByRefundType(){
    switch (this.formData.reasonType){
      case ReasonType.OTHERS_BUYER :
      case ReasonType.CHANGE_MIND :
        this.formData.responsibleObjectType = ResponsibleObjectType.BUYER
        return
    }

    this.formData.responsibleObjectType =  ResponsibleObjectType.SELLER
  }

  private changeSellerPaysClaimedDelivery(){
    this.formData.sellerPaysClaimedDelivery = this.formData.responsibleObjectType === ResponsibleObjectType.SELLER
  }

  private resetDeliveryProposedAmt(){
    if(this.formData.responsibleObjectType === ResponsibleObjectType.SELLER){
      this.formData.returnDeliveryProposedAmt = 0;
      this.formData.returnDeliveryProposedReason = '';
    }
  }

  private async postReturnsNoPredict(){
    const {
      responsibleObjectType,
      returnWayType,
      sellerPaysClaimedDelivery,
      refundAdjustAmt,
      returnDeliveryProposedAmt
    } = this.formData

    const {data} = await this.$api.postReturnsNoPredict({
      pathParams: {
        no: String(this.$route.query.claimNo)
      },
      data: {
        responsibleObjectType,
        returnWayType,
        sellerPaysClaimedDelivery,
        refundAdjustAmt: commaNumStringToNumber(refundAdjustAmt.toString()),
        returnDeliveryProposedAmt: commaNumStringToNumber(returnDeliveryProposedAmt.toString())
      }
    })

    this.returnsPredict = data
  }

  private alertMessageForFreeGift() {

    const hasTargetProduct = this.claimNoResponseData.claimedOptions.some(option => (option as any ).isGivenFreeGift);
    if (hasTargetProduct) {
      alert('사은품이 지급된 대상상품이 포함되어있습니다. \n사은품 지급 철회가 필요한 경우 \n사은품 상품도 클레임 처리해 주세요.');
      return;
    }

    const hasFreeGiftProduct = this.claimNoResponseData.claimedOptions.some(option => (option as any).isFreeGift);
    if (hasFreeGiftProduct) {
      alert('사은품 상품이 포함되어 있습니다. \n사은품 지급 대상상품의 클레임 처리가 필요한 경우 \n별도 처리해 주세요.');
    }
  }

  private checkTimePassedDelivery() {
    const RETURN_BASE_DAY_MILLISECONDS = 8 * 24 * 60 * 60 * 1000;
    const today = new Date();
    const deliveryComplete = new Date(this.deliveryCompleteYmdt) || today;
    const timePassedDelivery = Number(deliveryComplete) - Number(today); // 배송완료 후 지나간 시간
    if (timePassedDelivery < RETURN_BASE_DAY_MILLISECONDS) {
      // 배송완료 후 8일 이내인 경우, 얼럿 후 반품 가능
      alert(this.$t('CLAIM_POPUP_BEFORE_8DAYS_ALERT'));
      return true;
    } else {
      // 배송완료 후 8일 이상 지난 경우, 얼럿 후 반품 불가
      alert(this.$t('CLAIM_POPUP_AFTER_8DAYS_ALERT'));
      return false;
    }
  }

  // 반품처리
  private onReturnApprove(){
    this.alertMessageForFreeGift();

    if (this.isRental && !this.checkTimePassedDelivery()) {
      return;
    }

    if(!confirm(this.$t('CLAIM_POPUP_ASK_RETURN_APPROVE').toString())){
      return
    }

    const {invoiceNo, deliveryCompanyType, evadesReturnProcess} = this.formData.delivery
    const request = {
      pathParams: {
        no: String(this.$route.query.claimNo)
      },
      data: {
        invoiceNo: invoiceNo ? invoiceNo : null,
        deliveryCompanyType: deliveryCompanyType.length ? deliveryCompanyType : null,
        evadesReturnProcess: evadesReturnProcess,
      }
    }

    this.$api.putReturnsNoApprove(request).then(res => {
      alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'))
      this.onClickClose()
      this.reload()
    })
  }

  private onNaverPayReturnApprove(){
    if(!confirm(this.$t('반품요청 승인하시겠습니까?').toString())){
      return false;
    }

    this.$api.putClaimsNoNaverPayReturnsApprove({
      pathParams: {
        no: this.$route.query.claimNo.toString()
      }
    }).then(()=>{
      alert(this.$t('CLAIM_POPUP_ALERT_NAVER_PAY_PROCESS_SUCCESS'));
      this.onClickClose()
      this.reload()
    })
  }

  private onNaverPayReleaseHold(){
    if(!confirm(this.$t('CLAIM_POPUP_ASK_RETURN_RELEASE_HOLD').toString())){
      return false;
    }

    const request = {
      pathParams: {
        no: String(this.$route.query.claimNo)
      },
    }

    this.$api.putClaimsNoNaverPayReturnsReleaseHold(request).then(()=>{
      alert(this.$t('CLAIM_POPUP_ALERT_NAVER_PAY_PROCESS_SUCCESS'))
      location.reload()
    })
  }

  // 환불처리
  private onRefundConfirm(){
    if(!this.validation('refund')){
      return
    }

    if (this.isRental && !this.checkTimePassedDelivery()) {
      return;
    }

    if(!confirm(this.$t('CLAIM_POPUP_ASK_REFUND_MESSAGE').toString())){
      return
    }

    const {refundAdjustAmt, refundBankAccount, refundAdjustReason} = this.formData
    const isRefundAdjustReasonEmpty = refundAdjustReason === null || refundAdjustReason === undefined || refundAdjustReason.trim().length === 0

    let refundType = this.formData.refundType
    if(this.refundAmountComponent.adjustedAmounts.claimAmt === 0){
      refundType = RefundType.ZERO_REFUND
    }

    const request = {
      pathParams: {
        no: String(this.$route.query.claimNo)
      },
      data: {
        refundAdjustReason: isRefundAdjustReasonEmpty ? '' : refundAdjustReason.trim(),
        refundType,
        refundAdjustAmt: commaNumStringToNumber(refundAdjustAmt.toString()),
        refundBankAccount: refundType === 'ACCOUNT' || this.isVirtualAccount ? refundBankAccount : null // TODO: 가상계좌일 때 대응
      },
    }

    const apiMap = {
      [ClaimStatusType.RETURN_PROC_REQUEST_REFUND]: () => this.$api.putReturnsNoCashRefund(request),
      [ClaimStatusType.RETURN_REFUND_AMT_ADJUST_REQUESTED]: () => this.$api.putReturnsNoAdjustConfirm(request)
    }

    apiMap[this.claimStatusType]().then(res => {
      alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'))
      this.onClickClose()
      this.reload()

    })
  }

  // 반품신청철회
  private async onReturnWithdraw(){
    const confirmMessage = await this.checkAmountChangeAndGetConfirmMessage()

    if(!confirm(this.$t(confirmMessage).toString())){
      return
    }

    const request = {
      pathParams: {
        no: String(this.$route.query.claimNo)
      }
    }

    try{
      await this.$api.putReturnsNoWithdraw(request)

      alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'))
      this.onClickClose()
      this.reload()
    }catch(e){

    }
  }

  // 반품반려신청승인
  private onReturnWithdrawApprove(){
    if(!confirm(this.$t('CLAIM_POPUP_ASK_RETURN_WITHDRAW_APPROVE').toString())){
      return
    }

    this.$api.putReturnsNoApproveWithdraw({
      pathParams: {
        no: String(this.$route.query.claimNo)
      },
    }).then(res => {
      alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'))
      this.onClickClose()
      this.reload()
    })
  }

  // 반품수정
  private onModifyReturnClaim(){
    const {
      responsibleObjectType,
      refundType,
      reasonDetail,
      returnDeliveryProposedAmt,
      returnDeliveryProposedReason,
      sellerPaysClaimedDelivery,
      returnWayType,
      reasonType,
      refundBankAccount,
      delivery: {
        invoiceNo: invoiceNo,
        deliveryCompanyType: deliveryCompanyType,
        evadesReturnProcess: evadesReturnProcess
      }
    } = this.formData

    const request = {
      pathParams: {
        no: String(this.$route.query.claimNo)
      },
      data: {
        responsibleObjectType,
        refundType,
        reasonDetail,
        returnDeliveryProposedAmt: commaNumStringToNumber(returnDeliveryProposedAmt.toString()),
        returnDeliveryProposedReason,
        sellerPaysClaimedDelivery,
        returnWayType,
        deliveryCompanyType: deliveryCompanyType.length ? deliveryCompanyType : null,
        reasonType,
        invoiceNo,
        evadesReturnProcess,
        refundBankAccount,
        claimOrderOptions: []
      }

    }
    this.$api.putReturnsNo(request).then(res => {
      alert(this.$t('CLAIM_POPUP_MODIFY_SUCCESS_MESSAGE'))
      location.reload()
    })
  }

  // 수거완료 처리
  private onCompleteCollection(): void {
    ncpPopup(
        `/claim/collectReturnPopup?claimNo=${this.$route.query.claimNo}&callback=closeProcess`,
        window.$t('CLAIM_COLUMNS_PROC_COLLECT_COMPLETE'),
        800,
        400
    );
  }

  private closeProcess(): void {
    this.onClickClose();
    this.reload();
  }

  private validation(type: 'predict' | 'refund'): boolean{
    switch (type){
      case 'predict':
        const {payAmt} = this.claimNoResponseData.claimData.amounts.adjustedAmounts
        const refundAdjustAmt = this.claimNoResponseData.refundAdjustAmt
        const remitAmount = payAmt + refundAdjustAmt // 조정요청 -> 환불대기 -> 환불처리 스텝에서 연속적으로 조정금액을 입력할 수 있기 때문에 remitAmount 식 필요

        if(commaNumStringToNumber(this.formData.refundAdjustAmt.toString()) > remitAmount){
          alert(this.$t('CLAIM_POPUP_ADJUST_AMOUNT_EXCESS_VALID_MESSAGE'))
          this.formData.refundAdjustAmt = '0'
          return false
        }

        return true

      case 'refund':
        const {refundType, refundBankAccount, refundAdjustReason} = this.formData
        const isAccountEmpty = refundType === 'ACCOUNT' && refundBankAccount.account.trim().length === 0
        const isDepositerNameEmpty = refundType === 'ACCOUNT' && refundBankAccount.depositorName.trim().length === 0
        const isRefundAdjustAmtZero = commaNumStringToNumber(this.formData.refundAdjustAmt) === 0
        const isRefundAdjustReasonEmpty = refundAdjustReason === null || refundAdjustReason === undefined || refundAdjustReason.trim().length === 0

        if(isAccountEmpty){
          alert(this.$t('CLAIM_POPUP_MODIFY_ACCOUNT_VALID_MESSAGE'))
          return false
        }

        if(isDepositerNameEmpty){
          alert(this.$t('CLAIM_POPUP_MODIFY_DEPOSITOR_VALID_MESSAGE'))
          return false
        }

        if(!isRefundAdjustAmtZero && isRefundAdjustReasonEmpty){
          alert(this.$t('CLAIM_POPUP_MODIFY_ADJUSTMENT_REASON_VALID_MESSAGE'))
          return false
        }

        return true
    }
  }

  private get isVirtualAccount(){
    return this.formData.refundType === 'PG' && this.claimNoResponseData.originalPayType === 'VIRTUAL_ACCOUNT';
  }
}
